import { CountrySelect } from '@pandiafi/design-system'
import { Field, FieldProps } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { countryData } from '@kenno/resources'

import FormFieldWrapper from 'components/FormField'
import { FormFieldDescription } from 'components/FormField/FormFieldDescription'
import { BeneficiaryType } from 'views/TerminateContract/TerminateForm/initialValues'
import { isIbanCountry } from 'views/TerminateContract/utils/bankCountry'

interface BeneficiaryBankCountryFieldProps {
  index: number
  required: boolean
}

export const BeneficiaryBankCountryField: React.FC<
  BeneficiaryBankCountryFieldProps
> = ({ index, required }) => {
  const { t } = useTranslation(['terminateContract'])

  return (
    <Field name={`beneficiaries[${index}]bankCountryCode`}>
      {({
        field,
        form,
        meta,
      }: FieldProps<BeneficiaryType['bankCountryCode']>) => (
        <FormFieldWrapper
          name={field.name}
          required={required}
          label={t('terminateContract:labels.bankCountry')}
          className="min-tablet:flex-1"
          meta={meta}
          labelBold
          description={
            <div aria-live="polite">
              {field.value !== null && !isIbanCountry(field.value) && (
                <FormFieldDescription
                  text={t('terminateContract:texts.bankCountryWithoutIban')}
                />
              )}
            </div>
          }
        >
          <CountrySelect
            value={field.value}
            countryData={countryData}
            id={field.name}
            onChange={(countryCode) => {
              void form.setFieldValue(field.name, countryCode)
              void form.setFieldTouched(field.name, true, false)
            }}
          />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
